export default {
    name: 'Wasteland',
    logoVariant: 'dark',
    logo: {
        square: '/src/brands/wasteland/assets/square.png',
    },
    pwa: {
        name: 'Wasteland Resort Management',
        shortName: 'Wasteland Reps',
        themeColor: '#00bae3',
        backgroundColor: '#ffffff',
        icon: '/src/brands/wasteland/assets/icon.png',
        vapidPublicKey: 'BO6LHTcktRG1xwi5WAKtKKzmOy-Y4v1rr0Etqw8gXY5vYolkQATa1iHs_pq44R8XVOGm1UaI-lurI_ggeZQxv2E'
    }
}